module.exports = __webpack_public_path__ + "static/html_1-471bc3b98f584d738d224f9f197737f1.jpg";